export const sidePanelContents = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_SIDE_PANEL_CONTENT': {
      if (!action.payload || !action.payload.key) return state;
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    }
    case 'UPDATE_SIDE_PANEL_REPORT_COMPUTED': {
      if (!action.payload || !action.payload.key) return state;
      const result = {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          parcels: [
            {
              ...state[action.payload.key].parcels[0],
              ...action.payload.columns,
            },
          ],
        },
      };

      return result;
    }
    default:
      return state;
  }
};
